import PropTypes from 'prop-types';
// Import Configs
import { KPIWidgetsConfigs } from './config';
// Import Components
import KPIWidgetWrapper from './KPIWidgetWrapper';

const KPIWidgetsSection = ({ possibleWidgets, date }) => {
    return (
        <div className="widgets-wrap">
            {KPIWidgetsConfigs.map((item, index) => {
                if (possibleWidgets.includes(item.id)) {
                    return <KPIWidgetWrapper key={index} item={item} parentDate={date} />;
                }
                return <></>;
            })}
        </div>
    );
};

KPIWidgetsSection.propTypes = {
    date: PropTypes.array.isRequired,
    possibleWidgets: PropTypes.array,
};

KPIWidgetsSection.defaultProps = {
    possibleWidgets: [],
};

export default KPIWidgetsSection;
